import { theme, spacing, typography, isMobile } from '../styles/theme';
import SimpleHeader from '../components/SimpleHeader';

export default function TermsOfService() {
  return (
    <>
        <SimpleHeader />
        <div style={{
            backgroundColor: theme.bg.primary,
            position: 'fixed',
            top: '72px',
            left: 0,
            right: 0,
            bottom: 0,
            overflowY: 'auto',
            padding: spacing['3xl'],
            ...(isMobile() && {
                top: '70px',
                padding: spacing.lg,
            })
        }}>
            <div style={{
                maxWidth: '800px',
                margin: '0 auto',
                backgroundColor: 'white',
                padding: spacing['3xl'],
                borderRadius: '12px',
                boxShadow: theme.shadow.medium,
                // Mobile adjustments
                ...(window.innerWidth <= 768 && {
                    padding: spacing.lg,
                })
            }}>
                <div style={{ marginBottom: spacing.lg }}>
                    <a 
                        href="/" 
                        style={{
                            color: theme.brand.primary,
                            textDecoration: 'none',
                            fontSize: typography.fontSize.base,
                            fontWeight: typography.fontWeight.medium,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: spacing.xs,
                        }}
                    >
                        ← Back to Judgy
                    </a>
                </div>
                <h1 style={{
                        color: theme.text.primary,
                        fontSize: typography.fontSize['3xl'],
                        fontWeight: typography.fontWeight.bold,
                        marginBottom: spacing.xl,
                        fontFamily: typography.fontFamily.primary,
                    }}>
                        Terms of Service
                </h1>

                <p style={{ color: theme.text.secondary, marginBottom: spacing.lg }}>
                    <strong>Last Updated:</strong> October 27, 2025
                </p>
                <p style={{ color: theme.text.secondary, marginBottom: spacing.lg }}>
                    <strong>Version:</strong> 1.0
                </p>

            <div style={{
            color: theme.text.primary,
            fontSize: typography.fontSize.base,
            lineHeight: typography.lineHeight.relaxed,
            fontFamily: typography.fontFamily.primary,
            }}>
            {/* Introduction */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                1. Agreement to Terms
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                By accessing or using Judgy ("the Service"), you agree to be bound by these Terms of Service 
                ("Terms"). If you do not agree to these Terms, do not use the Service.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                These Terms constitute a legally binding agreement between you and Judgy ("we," "us," or "our"), 
                operated from Luxembourg.
                </p>
            </section>

            {/* Service Description */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                2. Description of Service
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                Judgy is an unofficial AI-powered assistant that provides guidance on Magic: The Gathering 
                rules and card interactions. The Service uses artificial intelligence to interpret the 
                Comprehensive Rules and provide casual rulings.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>Important Limitations:</strong>
                </p>
                <ul style={{ marginBottom: spacing.lg, paddingLeft: spacing.xl }}>
                <li style={{ marginBottom: spacing.sm }}>
                    Judgy is <strong>not a replacement for certified judges</strong> in official tournament play
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Responses may contain errors or inaccuracies
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    The Service is intended for casual, informational purposes only
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    For official rulings, always consult a certified judge or the official Comprehensive Rules
                </li>
                </ul>
            </section>

            {/* Unofficial Status */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                3. Unofficial Fan Project
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                Judgy is an unofficial fan project and is not affiliated with, endorsed by, or sponsored by 
                Wizards of the Coast LLC ("WotC"). Magic: The Gathering, MTG, and all related card names, 
                logos, and artwork are trademarks and copyrights of Wizards of the Coast LLC.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                Card data and images are provided by Scryfall. Judgy is not affiliated with Scryfall.
                </p>
            </section>

            {/* User Accounts */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                4. User Accounts
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                <strong>4.1 Account Creation:</strong> You may use basic features without an account. 
                Creating an account allows you to access premium features and flag responses.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>4.2 Account Security:</strong> You are responsible for maintaining the 
                confidentiality of your account credentials and for all activities under your account.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>4.3 Age Requirement:</strong> You must be at least 16 years old to create an account.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>4.4 Account Termination:</strong> We reserve the right to suspend or terminate 
                accounts that violate these Terms or engage in abusive behavior.
                </p>
            </section>

            {/* Usage Limits */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                    fontSize: typography.fontSize.xl,
                    fontWeight: typography.fontWeight.bold,
                    marginBottom: spacing.md,
                    color: theme.brand.primary,
                }}>
                    5. Usage Limits
                </h2>
                <p style={{
                    marginBottom: spacing.lg,
                }}>
                    To ensure fair access and maintain service quality, we implement the following usage limits:
                </p>
                <ul style={{
                    marginBottom: spacing.lg,
                    paddingLeft: spacing.xl,
                }}>
                    <li style={{ marginBottom: spacing.sm }}>
                        <strong>Free Users:</strong> 100,000 tokens per month (approximately 50-150 questions depending on complexity)
                    </li>
                    <li style={{ marginBottom: spacing.sm }}>
                        <strong>Premium Users:</strong> 1,000,000 tokens per month (approximately 500-1,500 questions depending on complexity)
                    </li>
                    <li style={{ marginBottom: spacing.sm }}>
                        Usage limits reset automatically on the 1st day of each month at 00:00 UTC
                    </li>
                    <li style={{ marginBottom: spacing.sm }}>
                        You will receive a warning when you reach 80% of your monthly limit
                    </li>
                    <li style={{ marginBottom: spacing.sm }}>
                        We reserve the right to adjust usage limits with reasonable notice to users
                    </li>
                    <li style={{ marginBottom: spacing.sm }}>
                        Anonymous users are tracked by IP address for usage limit purposes only
                    </li>
                </ul>
            </section>

            {/* Acceptable Use */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                6. Acceptable Use Policy
                </h2>
                <p style={{ marginBottom: spacing.md }}>You agree not to:</p>
                <ul style={{ marginBottom: spacing.lg, paddingLeft: spacing.xl }}>
                <li style={{ marginBottom: spacing.sm }}>
                    Use the Service for any illegal purpose or in violation of any laws
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Attempt to gain unauthorized access to our systems or other users' accounts
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Submit malicious content, spam, or abusive messages
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Use automated tools (bots, scrapers) to access the Service without permission
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Impersonate others or provide false information
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Attempt to reverse engineer or extract our AI models or algorithms
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Use the Service to harass, abuse, or harm others
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Overload or interfere with the proper functioning of the Service
                </li>
                </ul>
            </section>

            {/* Premium Subscription */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                7. Premium Subscription
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                <strong>7.1 Premium Features:</strong> Premium subscribers receive access to enhanced AI 
                responses (GPT-4.1 mini model) and power-user features. Refer to the About page for a detailed roadmapd of upcoming features.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>7.2 Payment:</strong> Premium is a monthly subscription of $5 USD, processed securely 
                through Stripe. You will be charged $5 at the start of each billing cycle.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>7.3 Cancellation and Refunds:</strong> You may cancel your Premium subscription at any time 
                through your account settings. Upon cancellation, Premium features remain active until the end of 
                your current billing period (30 days from your last payment). No refunds are provided for partial 
                billing periods. If you delete your account, Premium features terminate immediately with no refund.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>7.4 Changes to Premium:</strong> We reserve the right to modify premium features 
                or pricing for new purchases. Existing premium users retain their current benefits.
                </p>
            </section>

            {/* Intellectual Property */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                8. Intellectual Property
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                <strong>8.1 Our Content:</strong> The Judgy website, design, logo, and original content 
                are owned by us and protected by copyright and trademark laws. You may not copy, modify, 
                or distribute our content without permission.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>8.2 Third-Party Content:</strong> Magic: The Gathering content belongs to 
                Wizards of the Coast. Card data and images are provided by Scryfall.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>8.3 User Content:</strong> By submitting questions or feedback, you grant us 
                a non-exclusive, royalty-free license to use that content to improve the Service.
                </p>
            </section>

            {/* AI-Generated Content */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                9. AI-Generated Content and Accuracy
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                <strong>9.1 No Guarantee of Accuracy:</strong> Responses are generated by artificial 
                intelligence and may contain errors, inaccuracies, or outdated information. We do not 
                guarantee the accuracy, completeness, or reliability of any response.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>9.2 Not Official Rulings:</strong> Judgy's responses are not official rulings 
                and should not be cited as authoritative in tournament play or official events.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>9.3 Your Responsibility:</strong> You are responsible for verifying important 
                information with official sources or certified judges before relying on it.
                </p>
            </section>

            {/* Disclaimer of Warranties */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                10. Disclaimer of Warranties
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, 
                EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO:
                </p>
                <ul style={{ marginBottom: spacing.lg, paddingLeft: spacing.xl }}>
                <li style={{ marginBottom: spacing.sm }}>
                    Warranties of merchantability or fitness for a particular purpose
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Warranties of accuracy, reliability, or correctness of information
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Warranties of uninterrupted or error-free service
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Warranties that defects will be corrected
                </li>
                </ul>
                <p style={{ marginBottom: spacing.md }}>
                We do not warrant that the Service will meet your requirements or that it will be 
                suitable for any particular purpose.
                </p>
            </section>

            {/* Limitation of Liability */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                11. Limitation of Liability
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR:
                </p>
                <ul style={{ marginBottom: spacing.lg, paddingLeft: spacing.xl }}>
                <li style={{ marginBottom: spacing.sm }}>
                    Any indirect, incidental, special, consequential, or punitive damages
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Loss of profits, data, use, or goodwill
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Damages resulting from reliance on AI-generated responses
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Damages from unauthorized access to your account or data
                </li>
                <li style={{ marginBottom: spacing.sm }}>
                    Damages from service interruptions or errors
                </li>
                </ul>
                <p style={{ marginBottom: spacing.md }}>
                OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU PAID US IN THE PAST 12 MONTHS, 
                OR $60 USD (12 months × $5/month), WHICHEVER IS LESS.
                </p>
            </section>

            {/* Indemnification */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                12. Indemnification
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                You agree to indemnify, defend, and hold harmless Judgy and its operators from any claims, 
                damages, losses, liabilities, and expenses (including legal fees) arising from:
                </p>
                <ul style={{ marginBottom: spacing.lg, paddingLeft: spacing.xl }}>
                <li style={{ marginBottom: spacing.sm }}>Your use of the Service</li>
                <li style={{ marginBottom: spacing.sm }}>Your violation of these Terms</li>
                <li style={{ marginBottom: spacing.sm }}>Your violation of any third-party rights</li>
                <li style={{ marginBottom: spacing.sm }}>Your reliance on AI-generated responses</li>
                </ul>
            </section>

            {/* Advertising */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                13. Advertising
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                We do not display advertisements on Judgy. Premium subscriptions help support development and server costs.
                </p>
            </section>

            {/* Changes to Service */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                14. Changes to Service and Terms
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                <strong>14.1 Service Changes:</strong> We reserve the right to modify, suspend, or 
                discontinue any part of the Service at any time without notice.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>14.2 Terms Changes:</strong> We may update these Terms from time to time. 
                Material changes will be posted on this page with an updated "Last Updated" date. 
                Your continued use after changes constitutes acceptance.
                </p>
            </section>

            {/* Termination */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                15. Termination
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                <strong>15.1 By You:</strong> You may delete your account at any time through the 
                settings page.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>15.2 By Us:</strong> We may suspend or terminate your account if you violate 
                these Terms or engage in abusive behavior. If your account is terminated for violations, 
                you will not receive a refund for any remaining time in your billing period.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>15.3 Effect:</strong> Upon termination, your right to use the Service ceases 
                immediately. Provisions regarding liability, indemnification, and dispute resolution 
                survive termination.
                </p>
            </section>

            {/* Governing Law */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                16. Governing Law and Disputes
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                <strong>16.1 Governing Law:</strong> These Terms are governed by the laws of Luxembourg, 
                without regard to conflict of law principles.
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>16.2 Disputes:</strong> Any disputes arising from these Terms or the Service 
                shall be resolved through good-faith negotiation. If negotiation fails, disputes shall 
                be subject to the exclusive jurisdiction of the courts of Luxembourg.
                </p>
            </section>

            {/* Severability */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                17. Severability
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                If any provision of these Terms is found to be unenforceable or invalid, that provision 
                shall be limited or eliminated to the minimum extent necessary, and the remaining provisions 
                shall remain in full force and effect.
                </p>
            </section>

            {/* Contact */}
            <section style={{ marginBottom: spacing['2xl'] }}>
                <h2 style={{
                fontSize: typography.fontSize.xl,
                fontWeight: typography.fontWeight.bold,
                marginBottom: spacing.md,
                color: theme.brand.primary,
                }}>
                18. Contact Information
                </h2>
                <p style={{ marginBottom: spacing.md }}>
                If you have questions about these Terms, please contact us:
                </p>
                <p style={{ marginBottom: spacing.md }}>
                <strong>Email:</strong> <a href="mailto:support@askjudgy.com" 
                style={{ color: theme.brand.primary }}>support@askjudgy.com</a><br />
                <strong>Website:</strong> <a href="https://askjudgy.com" 
                style={{ color: theme.brand.primary }}>askjudgy.com</a>
                </p>
            </section>

            {/* Back to Home */}
            <div style={{
                textAlign: 'center',
                marginTop: spacing['3xl'],
                marginBottom: spacing['3xl'],
            }}>
                <a 
                href="/" 
                style={{
                    color: theme.brand.primary,
                    textDecoration: 'none',
                    fontSize: typography.fontSize.lg,
                    fontWeight: typography.fontWeight.semibold,
                }}
                >
                ← Back to Judgy
                </a>
            </div>
            </div>
        </div>
        </div>
    </>
  );
}